export default "__VITE_ASSET__DYbLe8bX__"